// ----------------------------------------------------------------------

function path(root: string, sublink: string) {
    return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/bxwm2';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
    root: ROOTS_AUTH,
    login: path(ROOTS_AUTH, '/login'),
    register: path(ROOTS_AUTH, '/register'),
};

export const PATH_DASHBOARD = {
    root: ROOTS_DASHBOARD,
    labels: {
        products: path(ROOTS_DASHBOARD, '/home')
    },
    general: {
        app: path(ROOTS_DASHBOARD, '/app'),
    },
};

export const PATH_DOCS = 'https://kb.bxsoftware.no/hjelp';
